export const categoryColors = [
  "#1272EF",
  "#45D0C2",
  "#744AFC",
  "#A056D2",
  "#FF1FC7",
  "#E64C4C",
  "#FC7019",
  "#FFD600",
  "#82C284",
  "#72AEFC",
];

export const MY_DASHBOARD_CHART_MAX_TXT_LEN = 8;
